<template>
  <FadeTransition>
    <template v-if="account && viewer">
      <AccountEditorTable :account="account" :viewer="viewer" />
    </template>
    <div v-else :class="$style.loader">
      <LoadingIndicator />
    </div>
  </FadeTransition>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'

import FadeTransition from '@/components/transitions/FadeTransition.vue'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'

import AccountEditorTable from './AccountEditorTable.vue'
import { useSettingsPageUsageViewQuery } from './SettingsPageUsageView.generated'
import type { Account } from '@/types/app'
import { parsePlannerProfileResponseToAccount } from '@/apis/repositories/parsers/planner.ts'

const { result, refetch } = useSettingsPageUsageViewQuery()
const viewer = computed(() => result.value?.viewer)
const account = computed<Account | undefined>(() => {
  const data = result.value?.planner
  if (data) {
    return parsePlannerProfileResponseToAccount({
      ...data,
      id: parseInt(data.id),
      corporationId: parseInt(data.corporationId),
      branchIds: data.branchIds.map(id => parseInt(id)),
      specialties: data.specialties.map(specialty => specialty.name),
    })
  }
  return undefined
})

const route = useRoute('usageSettings')
const entranceGUID = computed(() => route.params.entranceGUID)
watch(
  entranceGUID,
  () => {
    refetch()
  },
  { immediate: true }
)

useHead({
  title: '利用状況',
})
</script>

<style lang="scss" module>
.loader {
  display: flex;
  height: 560px;
  align-items: center;
  justify-content: center;
}
</style>
